// i18n配置
import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "../store";

const isDevelop = process.env.NODE_ENV == "development";
Vue.use(VueI18n);

const languageItems = _platformPrefs.pages.InnerPage.layout.languageItems

const messages = {
    "en-US": require("./en-US/index.js"),
    "zh-TW": require("./zh-TW/index.js"),
    "zh-CN": require("./zh-CN/index.js")
};

languageItems.map((item) => {
    if (!Object.keys(messages).includes(item)) {
        messages[item] = {}
        messages[item] = JSON.parse(JSON.stringify(require("./en-US/index.js")));
        messages[item].main.userLang = item
    }
})

var userLang = navigator.language || navigator.userLanguage;
// 預設使用者語言為en-US
userLang = Object.keys(messages).includes(userLang) ? userLang : "en-US";

// 依照rcm.js客製化i18n名稱, 修改i18n字典
if (typeof _platformPrefs !== "undefined" && !isDevelop) {
    store.commit("SET_I18N", _platformPrefs.i18n);
}
const { platformPrefs } = store.state;
let i18nDict = platformPrefs.i18n


if (i18nDict != '') {
    for (let [menu, menuObject] of Object.entries(i18nDict)) {
        for (let [submenu, subObject] of Object.entries(menuObject)) {
            for (let [lang, langContent] of Object.entries(subObject)) {
                if (langContent.trim() != '' && messages[lang] !== undefined) {
                    messages[lang][menu][submenu] = langContent;
                }
            }
        }
    }
}

// 創建 VueI18n 實例
const i18n = new VueI18n({
    locale: userLang,
    messages
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js